module.exports = __webpack_public_path__ + "8b3e14b572f58d991494c479b991dadc.svg";